import { createFileRoute } from '@tanstack/react-router';
import { ApplicationsTable } from '../../pages/platform/applications/ApplicationsTable';

// Lista de aplicaciones a nivel PLATAFORMA (`/platform/applications`). Reemplaza la pantalla deprecada
// de "Tipos de tenant". Es el `index` del segmento `applications` (mismo patrón que tenants.index): el
// segmento padre queda como pass-through con <Outlet/> para que el detalle `$applicationId` monte.
// Hereda el guard de scope PLATFORM del layout padre (_layout.platform); el gate fino del item de menú
// + acciones usa `platform.application.manage`.
export const Route = createFileRoute('/_authenticated/_layout/platform/applications/')({
    component: () => <ApplicationsTable />,
});
